module.exports = __webpack_public_path__ + "img/fingerprint-nine.b74d8c8f.svg";